module.exports = __webpack_public_path__ + "img/quicktips27.3125ecb7.svg";